import React from 'react';

import groupBy from 'lodash/groupBy';

import PipelineDataTable from '../PipelineDataTable/PipelineDataTable';
import PipelineListBlankSlate from './PipelineListBlankSlate';

const groupPipelinesById = (pipelines = []) => groupBy(pipelines, ({ pipelineID }) => pipelineID);

export const PipelineList = ({
  pipelines = [],
}) => {
  const groupedPipelines = pipelines?.length ? groupPipelinesById(pipelines) : null;

  return (
    !pipelines?.length ? (
      <PipelineListBlankSlate />
    ) : (
      <PipelineDataTable groupedPipelines={groupedPipelines} />
    )
  )
}

export default PipelineList;
